import { render, staticRenderFns } from "./RoomsList.vue?vue&type=template&id=6cf9d950&scoped=true&"
import script from "./RoomsList.vue?vue&type=script&lang=js&"
export * from "./RoomsList.vue?vue&type=script&lang=js&"
import style0 from "./RoomsList.vue?vue&type=style&index=0&id=6cf9d950&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9d950",
  null
  
)

export default component.exports